import {Box, Center, Flex, Image, Text, Skeleton} from '@chakra-ui/react'
import DateICon from '@assets/svgs/exam/date.svg'
import ClockICon from '@assets/svgs/exam/clock.svg'
import {useEffect, useState} from 'react'
import examRequest from '@apis/exam'
import moment from 'moment'
import {useNavigate} from 'react-router-dom'
import {PATH} from '@utils/Const'
import NoDataImage from '@assets/images/exam/not_data.png'

const ExamHistory = () => {
  const [isLoading, setIsLoading] = useState(true)
  const [results, setResults] = useState([])
  const navigate = useNavigate()

  useEffect(() => {
    getExamResult()
  }, [])

  useEffect(() => {
    const index = results.find((item: any) => item.status === 'PROCESSING')
    const interval = setInterval(() => {
      if (index) {
        getExamResult()
      }
    }, 5000)
    return () => clearInterval(interval)
  }, [results])

  const getExamResult = async () => {
    try {
      const res = await examRequest.getExamResults()
      if (res.status === 200) {
        setResults(res.data.data)
      }
      setIsLoading(false)
    } catch (error) {
      setIsLoading(false)
    }
  }

  const getColor = (status: any) => {
    switch (status) {
      case 'SUCCESS':
        return '#14AE5C'
      case 'PROCESSING':
        return '#CCA400'
      default:
        return 'red'
    }
  }

  const getDuration = (start_time: any, end_time: any) => {
    const date1 = moment(start_time)
    const date2 = moment(end_time)
    const differenceInMillis = date2.diff(date1)
    const duration = moment.duration(differenceInMillis)
    const hours = Math.floor(duration.asHours()).toString().padStart(2, '0')
    const minutes = duration.minutes().toString().padStart(2, '0')
    const seconds = duration.seconds().toString().padStart(2, '0')
    return `${hours}:${minutes}:${seconds}`
  }

  const handleClickResult = (item: any) => {
    if (item.status !== 'SUCCESS') {
      return
    }
    navigate(`${PATH.EXAM_RESULT}`, {state: {session_id: item.session_id}})
  }

  return (
    <Box p={{base: '16px', md: '32px'}} maxW="1200px" mx="auto">
      <Center
        fontSize={{base: '24px', md: '32px'}}
        fontWeight={700}
        mb={{base: '24px', md: '40px'}}
        borderBottom="3px solid #2B6CB0"
        pb={3}>
        Bài nói của bạn
      </Center>

      <Flex
        mt={{base: '16px', md: '32px'}}
        flexDirection={'column'}
        gap={{base: '16px', md: '24px'}}>
        {!isLoading ? (
          results.length > 0 ? (
            results.map((item: any, index: any) => (
              <Box
                key={index}
                p={{base: '16px', md: '24px'}}
                cursor={item.status === 'SUCCESS' ? 'pointer' : 'no-drop'}
                borderRadius={'16px'}
                border={'1px solid #e2e8f0'}
                boxShadow="sm"
                transition="all 0.2s"
                _hover={{
                  bg: '#f7fafc',
                  transform:
                    item.status === 'SUCCESS' ? 'translateY(-2px)' : 'none',
                  boxShadow: item.status === 'SUCCESS' ? 'md' : 'sm',
                }}
                onClick={() => handleClickResult(item)}>
                <Box>
                  <Text
                    fontSize={{base: '18px', md: '22px'}}
                    fontWeight={700}
                    noOfLines={1}
                    mb={3}>
                    <Text
                      as={'span'}
                      mr={'8px'}
                      color={getColor(item.status)}
                      fontSize="24px">
                      •
                    </Text>
                    {item.speak_test_name}
                  </Text>
                  <Flex
                    mt={{base: '16px', md: '8px'}}
                    gap={{base: '16px', md: '32px'}}
                    flexDirection={{base: 'column', md: 'row'}}
                    alignItems="center">
                    <Flex alignItems={'center'} gap={'10px'}>
                      <Image src={DateICon} w={'16px'} h={'16px'} />
                      <Text
                        fontSize={'15px'}
                        fontWeight={500}
                        color={'#4A5568'}>
                        {moment(item.start_time).format('YYYY-MM-DD HH:mm:ss')}
                      </Text>
                    </Flex>
                    <Flex alignItems={'center'} gap={'10px'}>
                      <Image src={ClockICon} w={'18px'} h={'18px'} />
                      <Text
                        fontSize={'15px'}
                        fontWeight={500}
                        color={'#4A5568'}>
                        {`Duration: ${getDuration(item.start_time, item.end_time)}`}
                      </Text>
                    </Flex>
                    <Flex
                      flex={1}
                      alignItems={'center'}
                      justifyContent={{base: 'flex-start', md: 'end'}}>
                      <Text
                        px={3}
                        py={1}
                        borderRadius="full"
                        bg={`${getColor(item.status)}15`}
                        fontSize={{base: '13px', md: '14px'}}
                        fontWeight={600}
                        color={getColor(item.status)}
                        whiteSpace="nowrap">
                        {item.status === 'FAILED' && 'Chấm thất bại'}
                        {item.status === 'SUCCESS' && 'Thành công'}
                        {item.status === 'PROCESSING' && 'Đang chấm'}
                      </Text>
                    </Flex>
                  </Flex>
                </Box>
              </Box>
            ))
          ) : (
            <Flex
              alignItems={'center'}
              mt={'100px'}
              flexDirection={'column'}
              bg="gray.50"
              p={10}
              borderRadius="xl">
              <Image src={NoDataImage} w={'160px'} mb={4} />
              <Text fontSize={'18px'} color="gray.600">
                Bạn chưa có bài nói nào cả.
              </Text>
            </Flex>
          )
        ) : (
          Array.from(Array(5)).map((_: any, index: any) => (
            <Box key={index} mb={'32px'}>
              <Skeleton height="16px" w={'150px'} />
              <Flex gap={'24px'} mt={'16px'}>
                <Skeleton height="16px" w={'200px'} />
                <Skeleton height="16px" w={'200px'} />
                <Flex flex={1} justifyContent={'end'}>
                  <Skeleton height="16px" w={'120px'} />
                </Flex>
              </Flex>
            </Box>
          ))
        )}
      </Flex>
    </Box>
  )
}

export default ExamHistory
